import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6 },
};

export default function BecomeClientSection() {
  return (
    <section className="relative w-full py-24 lg:py-32 overflow-hidden bg-[#0a0e1a]">
      {/* Liquid gradient blobs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="liquid-blob absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full bg-cyan-500/10 blur-[120px]" />
        <div className="liquid-blob absolute top-1/3 -right-40 w-[700px] h-[700px] rounded-full bg-blue-600/10 blur-[120px]" />
        <div className="liquid-blob absolute -bottom-40 left-1/3 w-[500px] h-[500px] rounded-full bg-sky-400/10 blur-[120px]" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        {/* Label */}
        <motion.span
          {...fadeUp}
          className="inline-block text-tech-green text-sm font-semibold tracking-[0.2em] uppercase mb-6"
        >
          Let&rsquo;s Build Something Secure
        </motion.span>

        {/* Main heading */}
        <motion.h2
          {...fadeUp}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight"
        >
          Become a{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyber-blue to-tech-green">
            Client
          </span>
        </motion.h2>

        {/* Subheading */}
        <motion.p
          {...fadeUp}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="text-xl md:text-2xl text-gray-300 font-medium mt-4"
        >
          Let&rsquo;s Engineer Your Digital Future
        </motion.p>

        {/* Description */}
        <motion.p
          {...fadeUp}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-gray-400 text-lg leading-relaxed mt-6 max-w-2xl mx-auto"
        >
          From cybersecurity infrastructure to modern software systems, Carium
          Tech helps businesses build secure, scalable, and future-ready digital
          solutions.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          initial="initial"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={{
            initial: {},
            show: { transition: { staggerChildren: 0.1 } },
          }}
          className="flex flex-col sm:flex-row gap-4 justify-center mt-10"
        >
          <motion.div
            variants={{
              initial: { opacity: 0, y: 20 },
              show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
            }}
          >
            <Link
              to="/contact"
              className="group inline-flex items-center gap-2 px-8 py-4 bg-cyber-blue text-black font-bold rounded-xl hover:bg-cyber-blue/90 transition-all hover:scale-105 hover:shadow-[0_0_30px_rgba(0,163,255,0.3)]"
            >
              Start a Project
              <svg
                viewBox="0 0 24 24"
                className="w-5 h-5 fill-current group-hover:translate-x-1 transition-transform"
              >
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
              </svg>
            </Link>
          </motion.div>

          <motion.div
            variants={{
              initial: { opacity: 0, y: 20 },
              show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
            }}
          >
            <Link
              to="/case-studies"
              className="inline-flex items-center gap-2 px-8 py-4 glass rounded-xl font-semibold text-gray-200 hover:text-white hover:bg-white/10 hover:border-cyber-blue/30 transition-all hover:scale-105"
            >
              View Case Studies
              <svg
                viewBox="0 0 24 24"
                className="w-5 h-5 fill-current"
              >
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
              </svg>
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
